import axios from 'axios'
import CONFIG from '../config'

axios?.interceptors?.request?.use((req) => {
    const url = req.url
    let domain = new URL(url)
    domain = domain.hostname

    const auth_token = localStorage.getItem('auth_token')
    const tp_preview_token = sessionStorage.getItem('tp_preview_token')

    if (CONFIG.testplayerUrls?.includes(domain)) {
        if (auth_token)
            req.headers['Authorization'] = localStorage.getItem('auth_token')
        else req.headers['token'] = tp_preview_token
    }
    return req
})

axios?.interceptors?.response?.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 412) {
            const testpanelElem = document.getElementById('testpanel')

            if (testpanelElem) {
                const event = new CustomEvent('logout', {
                    detail: {
                        message: err.response.data.detailMessage,
                    },
                })
                testpanelElem.dispatchEvent(event)
            }
        }

        return Promise.reject(err)
    },
)
